import { Ditto } from '@ow/ditto-core'
import * as DtText from '../fields/text'
import * as DtNumber from '../fields/number'
import * as DtDatetime from '../fields/datetime'
import * as DtDateRange from '../fields/date-range'
import * as DtDropSelect from '../fields/dropselect'
import * as DtSelect from '../fields/select'
import * as DtBoolean from '../fields/boolean'
import * as DtCascader from '../fields/cascader'
import * as DtOrg from '../fields/org'
import * as DtStandard from '../fields/standard'
import * as DtUser from '../fields/user'
import * as DtArea from '../fields/area'
import * as DtJudgeNull from '../fields/judgeNull'
import * as DtLocationWithText from '../fields/locationWithText'
import * as DtProduct from '../fields/product'
import * as DtMedia from '../fields/media'

export const ditto = new Ditto()

ditto.registeWidget('default', {
  render: DtText,
  filterSpec: DtText.filterSpec,
})
ditto.registeWidget('text', {
  render: DtText.Filter,
  filterSpec: DtText.filterSpec,
})
ditto.registeWidget('identifier', {
  render: DtText.Filter,
  filterSpec: DtText.filterSpec,
})
ditto.registeWidget('locationWithText', {
  render: DtLocationWithText.Filter,
  filterSpec: DtLocationWithText.filterSpec,
})
ditto.registeWidget('number', {
  render: DtNumber.Filter,
  filterSpec: DtNumber.filterSpec,
})
// ditto.registeWidget('orgMultiple', {
//   render: DtText.Filter,
//   filterSpec: DtText.filterSpec,
// })
ditto.registeWidget('datetime', {
  render: DtDatetime.Filter,
  filterSpec: DtDatetime.filterSpec,
})
ditto.registeWidget('dateRange', {
  render: DtDateRange.Filter,
  filterSpec: DtDateRange.filterSpec,
})
ditto.registeWidget('select', {
  render: DtSelect.Filter,
  filterSpec: DtSelect.filterSpec,
})
ditto.registeWidget('dropSelect', {
  render: DtDropSelect.Filter,
  filterSpec: DtDropSelect.filterSpec,
})
ditto.registeWidget('boolean', {
  // render: DtDropSelect.Filter,
  filterSpec: DtBoolean.filterSpec,
})
ditto.registeWidget('cascader', {
  render: DtCascader.Filter,
  filterSpec: DtCascader.filterSpec,
})

ditto.registeWidget('orgMultiple', {
  render: DtOrg.Filter,
  filterSpec: DtOrg.filterSpec,
})
ditto.registeWidget('org', {
  render: DtOrg.Filter,
  filterSpec: DtOrg.filterSpec,
})
ditto.registeWidget('standard', {
  render: DtStandard.Filter,
  filterSpec: DtStandard.filterSpec,
})
ditto.registeWidget('user', {
  render: DtUser.Filter,
  filterSpec: DtUser.filterSpec,
})
ditto.registeWidget('userMultiple', {
  render: DtUser.Filter,
  filterSpec: DtUser.filterSpec,
})
ditto.registeWidget('area', {
  render: DtArea.Filter,
  filterSpec: DtArea.filterSpec,
})
ditto.registeWidget('media', {
  render: DtText.Filter,
  filterSpec: DtMedia.filterSpec,
})
ditto.registeWidget('judgeNull', {
  render: DtJudgeNull.Filter,
  filterSpec: DtJudgeNull.filterSpec,
})
ditto.registeWidget('product', {
  render: DtProduct.Filter,
  filterSpec: DtText.filterSpec,
})

export default ditto
